import { render, staticRenderFns } from "./ActivityChannel.vue?vue&type=template&id=8de1ccc6&scoped=true&lang=html&"
import script from "./ActivityChannel.vue?vue&type=script&lang=js&"
export * from "./ActivityChannel.vue?vue&type=script&lang=js&"
import style0 from "./ActivityChannel.vue?vue&type=style&index=0&id=8de1ccc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de1ccc6",
  null
  
)

export default component.exports